const data = {};

data.checkIdentityNo = {
  data: {
    code: 0,
    message: 'success',
    data: null,
    debug: null,
  },
  // data: {
  //   "code": -1,
  //   "message": "에러메세지",
  //   "data": null,
  //   "debug": {}
  // }
};
data.checkBankAccount = {
  data: {
    code: 0,
    message: 'success',
    data: {
      accountOwnerName: '인증된상호',
    },
    debug: null,
  },
  // data: {
  //   "code": -1,
  //   "message": "에러메세지",
  //   "data": null,
  //   "debug": { 에러 관련 }
  // }
};

export default {
  ...data,
};
